module.exports = __webpack_public_path__ + "static/media/text-xyx.1312124f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/playground/components/face/img/faces/ym/text-xyx.svg
// module id = 401
// module chunks = 0